import {debounce} from 'lodash'

/**
 * Logo images can be any shape or size but we need them to fit neatly into specific sized boxes.
 * In modern browsers this can be achieved entirely with CSS object-fit:cover.
 *
 * targets: ObjectLiteral
 * {
 *    sizeImages: String - cssSelector,
 *    compareImages: String - cssSelector
 * }
 */

export default function (targets) {
  const elements = $(targets.sizeImages)

  if (elements.length) {
    elements.each(function () {
      console.log('each')
      const myelement = $(this)
      // Create debounced version of the resize function for use during window resize
      const debouncedElemMatchSizes = debounce(function () {
        matchSizes(myelement, targets)
      }, 150)

      // Resize images on page load, in case any logos are already visible or we've missed the lazyloaded event already
      debouncedElemMatchSizes()
      console.log(debouncedElemMatchSizes)
      // Resize logos on image lazyload
      $(window).on('lazyloaded', myelement, function () {
        console.log('lazyloaded')
        window.setTimeout(debouncedElemMatchSizes, 0)
        // Now that logo image is on screen, resize logos on window resize
        $(window).on('resize', debouncedElemMatchSizes)
      })
    })
  }
}

function matchSizes (element, targets) {
  const logoContainer = element
  const photoImageContainer = logoContainer.parent().find(targets.compareImages)
  const photoImage = photoImageContainer.find('img')
  const photoWidth = photoImage.outerWidth()
  const photoHeight = photoImage.outerHeight()
  const logoImage = logoContainer.find('img')
  // Set some starting CSS on the logo image to do further measurements from
  logoImage.css({'margin-left': 'auto', 'margin-right': 'auto', 'display': 'block', 'width': '100px', 'height': 'auto'})
  const lWidth = logoImage.outerWidth()
  const lHeight = logoImage.outerHeight()
  const isWideLogo = lWidth > (lHeight * photoWidth / photoHeight)
  console.log(lWidth, lHeight * photoWidth / photoHeight)
  // Force the dimensions of the bordered logo container
  logoContainer.css({'width': photoWidth, 'height': photoHeight})
  logoImage.css({'width': photoWidth, 'height': photoHeight})
  // Set the dimensions of the logo image
  let logoPad
  if (isWideLogo) {
    logoPad = parseInt(logoImage.parent().css('padding-left')) + parseInt(logoImage.parent().css('padding-right'))
    logoImage.css({'width': photoWidth - logoPad, 'height': 'auto'})
  } else {
    logoPad = parseInt(logoImage.parent().css('padding-top')) + parseInt(logoImage.parent().css('padding-bottom'))
    logoImage.css({'height': photoHeight - logoPad, 'width': 'auto'})
  }
  // Vertically align logo images within their boxes
  if (isWideLogo) {
    const autoLogoHeight = logoImage.outerHeight()
    const logoMarginTop = (((photoHeight - autoLogoHeight) / 2) - logoPad)
    console.log(lHeight * photoWidth / photoHeight, {lWidth, lHeight, isWideLogo, logoPad, autoLogoHeight, logoMarginTop})
    logoImage.css({'margin-top': logoMarginTop})
  } else {
    logoImage.css({'margin-top': 0})
  }
}
